export const MINIMUM_GAS_PRICE_WEI = 100000000n // 0.1 Gwei
export const EVM_DEFAULT_FEE_WEI = 5000000000000000n // Default fee in Wei (0.005 ETH) for EVM
export const EVM_GAS_BUFFER_MULTIPLIER = 2n // 2x buffer
export const SVM_RELAY_REQUESTS_API_BASE_URL =
  'https://api.relay.link/requests/v2'
export const SOLANA_FEE_BUFFER_MULTIPLIER = 5n // 5x buffer for Solana
export const SOLANA_DEFAULT_FEE_LAMPORTS = 1000000n // Default fee in lamports (0.001 SOL) for Solana
export const ECLIPSE_FEE_BUFFER_MULTIPLIER = 200n // 200x buffer for Eclipse
export const ECLIPSE_DEFAULT_FEE_WEI = 50000000000000n // Default fee in Wei (0.00005 ETH) for Eclipse
